import { render, staticRenderFns } from "./AddNewWithdrawal.vue?vue&type=template&id=50a035c4&scoped=true"
import script from "./AddNewWithdrawal.vue?vue&type=script&lang=js"
export * from "./AddNewWithdrawal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a035c4",
  null
  
)

export default component.exports